import { render, staticRenderFns } from "./observa4ResultTable.vue?vue&type=template&id=1a69ab1a&scoped=true"
import script from "./observa4ResultTable.vue?vue&type=script&lang=js"
export * from "./observa4ResultTable.vue?vue&type=script&lang=js"
import style0 from "./observa4ResultTable.vue?vue&type=style&index=0&id=1a69ab1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a69ab1a",
  null
  
)

export default component.exports